import http from "@/http-common";

const BASE = "/evaluation";

class EvaluationCategoryService {
  // ─── Category ─────────────────────────────────────
  getCategories() {
    return http.get(`${BASE}/category/list`);
  }

  createCategory(data) {
    return http.post(`${BASE}/category/create`, data);
  }

  updateCategory(id, data) {
    return http.put(`${BASE}/category/update/${id}`, data);
  }

  deleteCategory(id) {
    return http.delete(`${BASE}/category/delete/${id}`);
  }

  // ─── Template ─────────────────────────────────────
  getTemplates(categoryId) {
    return http.get(`${BASE}/template/list`, { params: { categoryId } });
  }

  createTemplate(data) {
    return http.post(`${BASE}/template/create`, data);
  }

  updateTemplate(id, data) {
    return http.put(`${BASE}/template/update/${id}`, data);
  }

  deleteTemplate(id) {
    return http.delete(`${BASE}/template/delete/${id}`);
  }
}

export default new EvaluationCategoryService();
